//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { SchedulerProvider } from './components/SchedulerContext/SchedulerContext' ;
import { ControlBox        } from './components/SchedulerControlBox/ControlBox'    ;
import { SchedulerTable    } from './components/SchedulerTable/SchedulerTable'     ;

//#endregion

//-----------------------------------------------------------------
export function SchedulerPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      backgroundColor: 'var(--bg-color-secondary)',
      padding: '1rem',
      width: '100%',
      display: 'inline-block',
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      sx: _styles.container,
    };


  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <SchedulerProvider>
          <ControlBox     />
          <SchedulerTable />
        </SchedulerProvider>
      </Box>
    );
  }

  //#endregion

  return display();
}
